import React from 'react'
import { Head } from '@inertiajs/react'

export default function UserProfile({ user, workspace, current_user, can_view_profile }) {
  return (
    <>
      <Head title={`${user.name} - Profile`} />

      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4">
          {/* Header */}
          <div className="bg-white shadow rounded-lg p-6 mb-6">
            <div className="flex items-start gap-4">
              {user.avatar_url ? (
                <img
                  src={user.avatar_url}
                  alt={user.name}
                  className="w-20 h-20 rounded-full"
                />
              ) : (
                <div className="w-20 h-20 rounded-full bg-blue-500 flex items-center justify-center text-white text-2xl font-bold">
                  {user.name.charAt(0).toUpperCase()}
                </div>
              )}

              <div className="flex-1">
                <h1 className="text-3xl font-bold text-gray-900">{user.name}</h1>
                <p className="text-gray-600">@{user.username}</p>
                {user.status && (
                  <p className="text-xs text-gray-500 uppercase tracking-wide mt-1">{user.status}</p>
                )}
                {user.email ? (
                  <p className="text-gray-500 text-sm mt-1">{user.email}</p>
                ) : (
                  <p className="text-gray-400 text-sm mt-1">
                    Contact details will be visible after this teammate accepts their invite.
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Workspace Info */}
          {can_view_profile ? (
            <div className="bg-white shadow rounded-lg p-6 mb-6">
              <h2 className="text-xl font-semibold mb-4">Workspace</h2>
              <p className="text-gray-700">{workspace.name}</p>
            </div>
          ) : (
            <div className="bg-white shadow rounded-lg p-6 mb-6">
              <h2 className="text-xl font-semibold mb-4">Limited Profile</h2>
              <p className="text-gray-600">
                {user.name.split(' ')[0]} hasn't shared project access with you yet. You'll see full details once they accept their invite or you collaborate on a project together.
              </p>
            </div>
          )}

          {/* Placeholder for future features */}
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Activity</h2>
            {can_view_profile ? (
              <p className="text-gray-500 italic">
                Recent worklogs and pairing history will appear here.
              </p>
            ) : (
              <p className="text-gray-400 italic">
                Activity becomes available once this teammate has active worklogs in your shared workspace.
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
